// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { sendActive } from '../../apis/base'
import { sendActiveActions } from '../actionCreators/sendActiveActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: sendActiveActions.success,
  failure: sendActiveActions.failure
};

type RequestActionTypes = ActionType<typeof sendActiveActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export default (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(sendActiveActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const { duration, organizationId, sourceFrom, sourceId, vodId } = action.payload;

      return sendActive(duration, organizationId, sourceFrom, sourceId, vodId)
        .then(() => {
          return outputActions.success({});
        })
        .catch((error: AxiosError) => {
          console.log('', error)
          return outputActions.failure({ error });
        })
    })
  );
};
